import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, TextField } from "@mui/material"
import GeneratingTokensIcon from '@mui/icons-material/GeneratingTokens';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useState } from "react";
import { useGetNewToken } from "../hooks/useGetNewToken";

export const GenerateToken = () => {
  const [userData, setUserData] = useState<{ token: string, userId: string }>(() => {
    const saved = localStorage.getItem("userData");
    return saved ? JSON.parse(saved) : {};
  });
  const { getNewToken, Snackbar } = useGetNewToken();

  const handleCopyToken = () => {
    const input = document.createElement('input');
    input.setAttribute('value', userData?.token);
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand('copy');
    document.body.removeChild(input);
    return result;
  }

  return (
    <>
      <FormControl>
        <InputLabel htmlFor="input-token">Token</InputLabel>
        <OutlinedInput label="Token" id="input-token" value={userData?.token || ""} slotProps={{
          input: {
            readOnly: true,
          },
        }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={handleCopyToken}
                edge="end"
              >
                <ContentCopyIcon />
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
      <TextField label="UserId" variant="outlined" value={userData?.userId} slotProps={{
        input: {
          readOnly: true,
        },
      }} />
      <button
        className="m-auto flex items-center gap-1 bg-blue-600 text-white px-3 rounded-lg text-sm hover:bg-blue-700 transition-colors"
        style={{ paddingTop: 4, paddingBottom: 4, background: "#1f8038" }}
        onClick={async () => {
          const data = await getNewToken();
          setUserData(data);
        }}
      >
        <GeneratingTokensIcon />
        Wygeneruj nowy token
      </button>
      <Snackbar messages={{ working: 'Pobieram token', done: 'Token pobrany' }} />
    </>
  )
}
